import React, { Component } from 'react';
import { connect } from 'react-redux';
import CLIENT from '../../../utils/restClient';
import BusySpinner from '../../spinners/BusySpinner';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import FileSaveAs from '../../downloaders/FileSaveAs';
import AceEditor from 'react-ace';
import prettifyXML from 'prettify-xml';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import StaticApplicationMessage from '../../inAppMessages/StaticApplicationMessage';

const isUrl = require('is-url');
const log = new Logger('XML_URI_VIEWER', LOG_LEVELS.DEBUG);
const xmlFontSize = 12;
export class XmlUriViewer extends Component {

  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.setErrorState = this.setErrorState.bind(this);
    this.setSuccessState = this.setSuccessState.bind(this);
    this.fetchAndPreview = this.fetchAndPreview.bind(this);
    this.onDownloadFilingDocument = this.onDownloadFilingDocument.bind(this);
    this.elementForXmlViewer = null;
    this.state = {
      loading: true,
      data: undefined,
      error: undefined,
      tooLarge: false
    };
  }
  
  render() {
    log.debug('render(): ', this.props);
    const filename = this.props.filename || (() => {
      const split = this.props.uri.split('/');
      return split[split.length -1];
    })();


    if (this.state.tooLarge) {
      return (
        <div data-test="component-xml-uri-viewer-too-large" className="mb10">
            <StaticApplicationMessage
              messageType="applicationInfo"
              string="xmlUriViewer_tooLargeMessage"
              languages={this.props.languages}
              nodismiss
            />
        </div>
      );
    }

    return (
      <div>
        <BusySpinner busy={this.state.loading}/>
        {
          this.state.data ? 
          (
            <div data-test="component-xml-uri-viewer"> 
              <div>
                <AceEditor
                  mode="xml"
                  readOnly={true}
                  fontSize={xmlFontSize}
                  showPrintMargin={false}
                  showGutter={true}
                  highlightActiveLine={false}
                  value={prettifyXML(this.state.data)}
                  width={'100%'}
                  maxLines={this.props.maxLines}
                  wrapEnabled={true}
                  setOptions={{
                  enableBasicAutocompletion: false,
                  enableLiveAutocompletion: false,
                  enableSnippets: false,
                  showLineNumbers: false
                  }}/>
              </div>
             <br/>
              {!this.props.hideDownload && (
                <FileSaveAs
                  content ={this.state.data}
                  fetchContent={this.onDownloadFilingDocument}
                  downloadLabel={`Download ${filename}.${this.props.fileExtension}`}
                  filename={filename}
                  mimeType="application/xml"
                  isBlob={true}
                />
              )}
            </div>
          ) : this.state.error ? ( <div data-test="component-xml-uri-viewer-error" ><span></span></div>): ( <div data-test="component-xml-uri-viewer-loading" ><span> <LanguageStringResolver string='xmlUriViwer_loading'/> {filename}</span></div>)
        }
      </div>
    );
  }

  fetchData(callback=()=>{}) {
    log.debug('fetchData() ');
    if(!isUrl(this.props.uri)) {
      callback(null, new Error("Invalid uri!"));
      return;
    }
    CLIENT.getFilingDocumentAsText('XML', this.props.uri)
      .then((response) => {
        log.debug('fetchData(): getFilingDocumentAsText got a response ');
        callback(response, null);
      })
      .catch((error) => {
        log.debug('fetchData(): getFilingDocumentAsText got an error   ', error);
        callback(null, error);
      });
  }
  onDownloadFilingDocument () {
    log.debug('onDownloadFilingDocument()');
    return new Promise((resolve, reject)=>{
      CLIENT.getFilingDocumentAsBlob('Blob', this.props.uri).then((data) => {
        const downloadData = {
          content: data || '', ext: this.props.fileExtension
        };
        resolve(downloadData);
      }).catch((err) =>{
        reject(err);
        return;
      })
    });
  }

  setErrorState(error) {
    log.debug('setErrorState() - error: ', error);
    this.setState({
      loading: false,
      data: undefined,
      error: error,
      tooLarge: false
    });
  }

  setSuccessState(data) {
    log.debug('setSuccessState() - data: ', data);
    this.setState({
      loading: false,
      data: data,
      error: undefined,
      tooLarge: false
    });
  }

  setTooLargeState() {
    log.debug('setTooLargeState()');
    this.setState({
      loading: false,
      data: undefined,
      error: undefined,
      tooLarge: true
    });
  }

  fetchAndPreview() {
    log.debug('fetchAndPreview(): ');
    this.fetchData((response, error) => {
      if(error){
        this.setErrorState(error);
        return;
      }
      if (this.shouldEnforceSizeLimit() && this.exceedsSizeLimit(response)) {
        this.setTooLargeState();
        return;
      }
      this.setSuccessState(response);
    });
  }

  shouldEnforceSizeLimit() {
    const { enforceSizeLimit, sizeLimitBytes } = this.props;
    return Boolean(enforceSizeLimit) &&
      typeof sizeLimitBytes === 'number' &&
      Number.isFinite(sizeLimitBytes) &&
      sizeLimitBytes > 0;
  }

  exceedsSizeLimit(text) {
    return new Blob([text]).size > this.props.sizeLimitBytes;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.uri !== this.props.uri ||
        prevProps.enforceSizeLimit !== this.props.enforceSizeLimit ||
        prevProps.sizeLimitBytes !== this.props.sizeLimitBytes) {
      this.fetchAndPreview();
    }
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.fetchAndPreview();
  }
  

}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


XmlUriViewer.defaultProps = {
  hideDownload: false,
  maxLines: Infinity,
  enforceSizeLimit: false
};


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(XmlUriViewer);
